import React, { useEffect, useState, useMemo, useRef } from 'react';
import { BsArrowLeft, BsInfoCircle } from 'react-icons/bs';
import { AiOutlineUpload } from 'react-icons/ai';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/styles/register.css';
import RegisterHeader from '.././header/RegisterHeader'
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import FileUploadModal from '../popupmodels/FileUploadModal';
import { useLocation } from 'react-router-dom';


const MAX_FILE_SIZE_MB = 5;
const OTP_TIMER_SECONDS = 30; // Define the timer duration

// Define your base URL here
// const baseUrl = "http://localhost:8000/api";
// const baseUrl = "https://devapi.ariseforyou.com/api";
const baseUrl = "https://prodapi.ariseforyou.com/api" 

const StudentDetailsPage = ({ setIsStudentUpdated }) => { // Accept setIsStudentUpdated prop

  const [states, setStates] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  // OTP Timer State
  const [otpSent, setOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0); // Countdown in seconds
  const timerRef = useRef(null); // Ref to hold the interval ID


  // handle file from modal
  const handleFileFromModal = (file) => {
    handleFileChange({ target: { files: [file] } });
  };


  const [formData, setFormData] = useState({
    institution: '',
    department: '',
    year: '',
    registerNumber: '',
    email: '',
    otp: '',
    password: '',
    state: "",
    collegeIdCard: null,
  });
  const [errors, setErrors] = useState({});
  const [fileName, setFileName] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sid = queryParams.get("sid");
  const semail = queryParams.get("semail");
  const [student, setStudent] = useState(null);


  // --- MODIFIED basicDetailsFields ARRAY ---
  const basicDetailsFields = [
    { id: 'institution', label: 'Institution', required: true, placeholder: 'Institution' },
    { id: 'department', label: 'Department', required: true, placeholder: 'Department' },
    { id: 'year', label: 'Year of Study', required: true, placeholder: 'Enter Year' },
    { id: 'state', label: 'State', required: true, placeholder: 'Select State' },
    { id: 'registerNumber', label: 'Student Register Number', required: true, placeholder: "Enter Student's Registration Number" },
    // Student College ID Document is handled separately below, outside this array
  ];

  const FormLabel = ({ children, required = false, htmlFor }) => (
    <label htmlFor={htmlFor} className="form-label fw-bold">
      {children}
      {required && <span className="text-danger"> *</span>}
    </label>
  );


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIsFormTouched(true);
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const ALLOWED_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png"];

  const handleFileChange = (e) => {
    setIsFormTouched(true);
    const file = e.target.files[0];

    if (file) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        setErrors((prev) => ({
          ...prev,
          collegeIdCard: "Only JPG, JPEG, PNG files are allowed",
        }));
        setFormData((prev) => ({ ...prev, collegeIdCard: null }));
        setFileName("");
        return;
      }

      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          collegeIdCard: `File must be ≤ ${MAX_FILE_SIZE_MB}MB`,
        }));
        setFormData((prev) => ({ ...prev, collegeIdCard: null }));
        setFileName("");
        return;
      }

      setFormData((prev) => ({ ...prev, collegeIdCard: file }));
      setErrors((prev) => ({ ...prev, collegeIdCard: "" }));
      setFileName(file.name);
    }
  };


  const validate = () => {
    const newErrors = {};
    const requiredFields = [
      'institution', 'department', 'year', 'registerNumber', "state",
      'email', 'otp', 'password', 'collegeIdCard'
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = 'This field is required';
      }
    });
    if (formData.collegeIdCard && formData.collegeIdCard.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      newErrors.collegeIdCard = `File must be ≤ ${MAX_FILE_SIZE_MB}MB`;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  useEffect(() => {
    if (isSubmitting) {
      const formIsValid = validate();
      setIsFormValid(formIsValid);
    }
  }, [formData, isSubmitting]);



  useEffect(() => {
    const fetchStates = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/state`);
        if (data.success && Array.isArray(data.result)) {
          setStates(data.result);
        } else {
          console.error("API response for states did not contain success: true or result array.");
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);


  const fetchStudent = async () => {
    if (!sid) return;

    try {
      const { data } = await axios.get(`${baseUrl}/student/${sid}`);
      if (data.success) {
        setStudent(data.result); // use data.result, NOT data.data
      } else {
        toast.error(data.message || "Student not found");
      }
    } catch (error) {
      console.error("Error fetching student:", error);
      toast.error("Failed to fetch student details");
    }
  };

  useEffect(() => {
    fetchStudent();
  }, [sid]);


  useEffect(() => {
    if (student) {
      setFormData((prev) => ({
        ...prev,
        email: student.email || '',
        institution: student.institution || '',
        department: student.department || '',
        year: student.year_of_study || '',
        registerNumber: student.student_register_number || '',
        state: student.state || '',
        collegeIdCard: null, // always fresh upload
      }));
    }
  }, [student]);



  useEffect(() => {
    const fetchInstitutes = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/institutes`);
        if (data.success && Array.isArray(data.result)) {
          setInstitutes(data.result);
        } else {
          console.error("API response for institutes did not contain success: true or result array.");
        }
      } catch (error) {
        console.error("Error fetching institutes:", error);
      }
    };

    fetchInstitutes();
  }, []);

  // Effect for OTP timer
  useEffect(() => {
    if (otpSent && otpTimer > 0) {
      timerRef.current = setInterval(() => {
        setOtpTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (otpTimer === 0) {
      clearInterval(timerRef.current);
    }

    return () => clearInterval(timerRef.current); // Cleanup on unmount
  }, [otpSent, otpTimer]);


  const handleSendOtp = async () => {
    setIsFormTouched(true);

    if (!formData.email) {
      toast.error("Enter Email to receive OTP");
      return;
    }

    // Reset timer and set otpSent to true
    setOtpTimer(OTP_TIMER_SECONDS);
    setOtpSent(true); 

    try {
      const { data } = await axios.post(`${baseUrl}/student/send-otp`, {
        email: formData.email,
      });

      if (data.success) {
        toast.success("OTP sent to your email");
      } else {
        toast.error(data.message || "Failed to send OTP");
        // If OTP sending fails, reset otpSent and timer
        setOtpSent(false);
        setOtpTimer(0);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error sending OTP");
      // If OTP sending fails, reset otpSent and timer
      setOtpSent(false);
      setOtpTimer(0);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormTouched(true);

    const formIsValid = validate();
    if (!formIsValid) {
      toast.error("Please fill in all mandatory fields correctly.");
      return;
    }

    setIsSubmitting(true);

    try {
      const data = new FormData();
      data.append("sid", sid);                // from URL params
      data.append("semail", semail);          // from URL params
      data.append("otp_code", formData.otp);
      data.append("password", formData.password);
      data.append("institution", formData.institution);
      data.append("department", formData.department);
      data.append("year_of_study", formData.year);
      data.append("student_register_number", formData.registerNumber);
      data.append("state", formData.state);
      if (formData.collegeIdCard) {
        data.append("student_college_id_doc", formData.collegeIdCard);
      }

      const response = await axios.post(
        `${baseUrl}/student/update-student-after-payment`,
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.success) {
        toast.success("Student details updated successfully!");
        setIsStudentUpdated(true);
      } else {
        // Show API error message
        toast.error(response.data.message || "Update failed!");
      }
    } catch (err) {
      console.error("Error updating student:", err);
      // If API responded with message
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Server error. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };



  const handleSelectChange = (selectedOption, action) => {
    const { name } = action;
    const value = selectedOption ? selectedOption.value : '';
    setIsFormTouched(true);
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };



  const institutionOptions = useMemo(() =>
    institutes.map(inst => ({
      value: inst.institution_name,
      label: inst.institution_name,
    })),
    [institutes]
  );

  const stateOptions = useMemo(() =>
    states.map(st => ({
      value: st.state_name,
      label: st.state_name,
    })),
    [states]
  );

  return (
    <>
      {/* <RegisterHeader /> */}
      {/* <div className="d-flex align-items-center gap-3 m-4">
        <button
          onClick={() => navigate("/")}
          className="btn rounded-circle p-2 lh-1"
          style={{ background: "#F4F4F4" }}
        >
          <BsArrowLeft size={20} />
        </button>
        <h1 className="h4 mb-0 fw-semibold">Registration Details</h1>
      </div> */}
      <></>

      <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">
        <ToastContainer />
        <div className="p-4 p-md-5 rounded-3 w-100 border" style={{ background: "#fff" }}>
          <form onSubmit={handleSubmit}> {/* This form now wraps everything */}
            {/* Sign in Details */}
            <div className="mt-5">
              <div className="d-flex align-items-center mb-3 mt-5">
                <h2 className="h5 fw-bold mb-0 me-3">Sign in Details</h2>
                <div className="flex-grow-1">
                  <hr className="mt-0 mb-0" />
                </div>
              </div>
              <div className="row g-4">
                <div className="col-12">
                  <FormLabel htmlFor="email" required>
                    Email
                  </FormLabel>
                  <div className="d-flex align-items-center gap-3 w-50">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      placeholder="Enter your email id"
                      onChange={handleInputChange}
                      className="form-control"
                      disabled={otpSent && otpTimer > 0} // Disable email input during countdown
                    />

                    {otpSent && otpTimer > 0 ? (
                      <button
                        type="button"
                        className="btn btn-outline-custom"
                        style={{ minWidth: "120px" }}
                        disabled // Disabled during countdown
                      >
                        Resend in {otpTimer}s
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={handleSendOtp}
                        className="btn btn-outline-custom"
                        style={{ width: "150px" }}
                        disabled={!formData.email} // Disable if email is empty
                      >
                        {otpSent ? "Resend OTP" : "Send OTP"}
                      </button>
                    )}
                  </div>
                  {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
                </div>

                {/* OTP and Password in a single row */}
                <div className="col-12 d-flex flex-wrap flex-md-nowrap gap-4">
                  <div className="col-md-6">
                    <FormLabel htmlFor="otp" required>
                      OTP Verification
                    </FormLabel>
                    <input
                      type="text"
                      id="otp"
                      name="otp"
                      placeholder="Enter OTP"
                      value={formData.otp}
                      onChange={handleInputChange}
                      className="form-control w-100"
                    />
                    {errors.otp && <div className="text-danger small mt-1">{errors.otp}</div>}
                  </div>
                  <div className="col-md-6">
                    <FormLabel htmlFor="password" required>
                      Password
                    </FormLabel>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Enter a password"
                      value={formData.password}
                      onChange={handleInputChange}
                      className="form-control w-100"
                    />
                    {errors.password && <div className="text-danger small mt-1">{errors.password}</div>}
                  </div>
                </div>
              </div>
            </div>

            {/* Basic Details */}
            <div className="mb-4 mt-5">
              <div className="d-flex align-items-center mb-3">
                <h2 className="h5 fw-bold mb-0 me-3">Additional Details</h2>
                <div className="flex-grow-1">
                  <hr className="mt-0 mb-0" />
                </div>
              </div>
              <div className="row g-4">
                {basicDetailsFields.map(({ id, label, required, placeholder }) => (
                  <div className="col-md-4" key={id}>
                    <FormLabel htmlFor={id} required={required}>
                      {label}
                    </FormLabel>
                    {id === "institution" ? (
                      <Select
                        id="institution"
                        name="institution"
                        options={institutionOptions}
                        value={institutionOptions.find(option => option.value === formData.institution)}
                        onChange={(selectedOption, action) => handleSelectChange(selectedOption, { name: "institution" })}
                        placeholder="Search and select Institution"
                        isClearable
                      />
                    ) : id === "state" ? (
                      <Select
                        id="state"
                        name="state"
                        options={stateOptions}
                        value={stateOptions.find(option => option.value === formData.state)}
                        onChange={(selectedOption, action) => handleSelectChange(selectedOption, { name: "state" })}
                        placeholder="Search and select State"
                        isClearable
                      />
                    ) : id === "year" ? (
                      <select
                        id="year"
                        name="year"
                        value={formData.year}
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value="">Select Year</option>
                        <option value="1">1st year </option>
                        <option value="2">2nd year</option>
                        <option value="3">3rd year</option>
                        <option value="4">4th year</option>
                        <option value="5">5th year</option>
                      </select>
                    ) : (
                      <input
                        type="text"
                        id={id}
                        name={id}
                        value={formData[id]}
                        placeholder={placeholder}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    )}

                    {errors[id] && (
                      <div className="text-danger small mt-1">{errors[id]}</div>
                    )}
                  </div>
                ))}

                {/* Student College ID Document field (remains in its own div as it's a special input) */}
                <div className="col-md-4">
                  <div className="d-flex align-items-center gap-1">
                    <FormLabel htmlFor="file-upload" required>
                      Student College ID Document
                    </FormLabel>
                    <BsInfoCircle
                      className="text-muted"
                      title="Allowed format: png, jpeg, jpg,(Less than 5mb)"
                    />
                  </div>

                  {/* Open modal on click */}
                  <div
                    className="form-control d-flex align-items-center justify-content-center gap-2 text-muted"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowUploadModal(true)}
                  >
                    <AiOutlineUpload />
                    <span>{fileName || "Upload Student's College ID Card"}</span>
                  </div>

                  {errors.collegeIdCard && (
                    <div className="text-danger small mt-1">
                      {errors.collegeIdCard}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end mt-5">
              <button
                type="submit"
                className="btn btn-custom px-5"
              // disabled={isSubmitting || !isFormValid}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>

      <FileUploadModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onFileSelect={handleFileFromModal}
      />
    </>
  );
};

export default StudentDetailsPage;